<script>
  import { onMount, getContext, onDestroy } from 'svelte';
  import { client } from 'root/api/index.js';
  import ProfileImg from './ProfileImage.svelte';
  import Loader from './Loader.svelte';
  import InfiniteScroll from './DataTable/InfiniteScroll.svelte';
  import { displayTimeAgo } from 'components/Helper.js';
  import ReadMore from 'components/ReadMore/ReadMore.svelte';
  const showDialog = getContext('showDialog');
  export let id = 0;
  let isFormPending = false;
  let pageSize = 30;
  let pageNumber = 1;
  let hasMore = false;
  let taskCommentsData = [];
  let isPaginationLoading = false;
  let photoUrl =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcL_hveDzFBZFoTZ8qs902bi097hHDNIsfCg&usqp=CAU';
  let defaultValue = {
    id: '',
    taskId: '',
    notes: '',
    saveClient: 0,
    client: false,
  };
  let commentError = false;
  let commentValues = { ...defaultValue };
  export const show = (taskId) => {
    pageNumber = 1;
    hasMore = false;
    taskCommentsData = [];
    id = taskId;
    commentValues.taskId = id;
    getNotesList();
  };

  const showDelete = (selectId) => {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure?',
      okFunc: () => {
        client
          .taskNoteDelete({ id: selectId, taskId: id })
          .then((response) => {
            show(id);
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  };
  const showEdit = (selectId) => {
    client
      .taskNoteGet({ id: selectId, taskId: id })
      .then((response) => {
        commentValues = {
          ...defaultValue,
          taskId: response.data.notes.task_id,
          id: response.data.notes.id,
          notes: response.data.notes.notes,
        };
        tagify.container.firstChild.innerHTML = commentValues.notes;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const getNotesList = () => {
    if (id == 0) {
      return;
    }
    isPaginationLoading = true;
    let firstId = taskCommentsData.length > 0 ? taskCommentsData[0].id : '';
    client
      .taskNotesList(pageSize, pageNumber, { taskId: id, firstId })
      .then((response) => {
        isPaginationLoading = false;
        if (firstId > 0) {
          taskCommentsData = response.data.payload.concat(taskCommentsData);
        } else {
          taskCommentsData = response.data.payload;
        }
        hasMore = response.data.hasMore;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  let tagify;
  const handleSubmit = () => {
    if (commentValues.notes == '') {
      commentError = true;
      return;
    }

    isFormPending = true;
    let value = { ...commentValues };
    commentValues = { ...defaultValue };
    client
      .taskNoteSave(value)
      .then((response) => {
        isFormPending = false;
        commentValues = { ...defaultValue };
        show(id);
        tagify.setContents('');
      })
      .catch((err) => {
        isFormPending = false;
        serverErrors = [err.message];
        showDialog({ message: serverErrors });
      });
  };

  import { Popover } from 'bootstrap';
  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      el.remove();
    });
    var elements = document.querySelectorAll('.subtask_popover');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  import 'quill-mention';
  import ReadMoreHeight from './ReadMore/ReadMoreHeight.svelte';
  let tagifyRef;
  const bindTagify = async () => {
    let toolbarOptions = [
      [
        { header: 1 },
        { header: 2 },
        'blockquote',
        'bold',
        'italic',
        'underline',
        'strike',
        { list: 'bullet' },
        { list: 'ordered' },
      ],
    ];
    const { default: Quill } = await import('quill');
    tagify = new Quill(tagifyRef, {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: 'snow',
      placeholder: 'Enter your comments here...',
    });
    tagify.on('text-change', function (delta, oldDelta, source) {
      commentValues.notes =
        tagify.getText().trim() != '' || tagify.getContents().length > 1
          ? tagify.container.firstChild.innerHTML
          : '';
    });
  };

  const keyboardListnerStatus = getContext('keyboardListnerStatus');
  onMount(() => {
    initPopupOver();
    keyboardListnerStatus(true);
    bindTagify();
  });
  onDestroy(() => {
    keyboardListnerStatus(false);
  });
</script>

<div class="page-content p-3">
  {#if taskCommentsData.length <= 0 && !isPaginationLoading}
    <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
      <svg
        width="55"
        height="55"
        viewBox="0 0 100 100"
        fill="#C8D6E7"
        xmlns="http://www.w3.org/2000/svg"
        ><path
          d="M91 14V70.8285H38.2686L19.25 90V70.8285H9V14H91ZM85.875 19.1662H14.125V65.6622H24.375V77.488L36.1064 65.6622H85.875V19.1662ZM60.25 44.9973H55.125V34.6649H65.375V44.9973C65.375 45.7238 65.2415 46.3965 64.9746 47.0154C64.7077 47.6343 64.3473 48.1724 63.8936 48.6298C63.4398 49.0873 62.8926 49.464 62.252 49.76C61.6113 50.0559 60.944 50.1905 60.25 50.1636V44.9973ZM39.75 44.9973H34.625V34.6649H44.875V44.9973C44.875 45.7238 44.7415 46.3965 44.4746 47.0154C44.2077 47.6343 43.8473 48.1724 43.3936 48.6298C42.9398 49.0873 42.3926 49.464 41.752 49.76C41.1113 50.0559 40.444 50.1905 39.75 50.1636V44.9973Z"
          fill=""
        /></svg
      >
      <span class="color-lead font-size-18 mt-2 d-block">There are no task comments yet</span>
    </div>
  {/if}
  {#each taskCommentsData as itemData, itemkey}
    <div class="comments-list mb-3">
      <div class="d-flex flex-row">
        <div class="comments-user-profile-img d-flex me-3">
          <ProfileImg
            size={40}
            photoUrl={itemData.user.photoUrl}
            firstName={itemData.user.firstName}
            lastName={itemData.user.lastName}
            className="d-inline-block align-middle"
          />
        </div>
        <div class="w-100">
          <div class="d-flex flex-row justify-content-between">
            <span class="font-weight-500"
              >{itemData.user.firstName}
              {itemData.user.lastName}</span
            >
            <small class="text-muted d-flex align-items-center">
              <img
                alt=""
                class="me-1 icon-14"
                src="/images/clock.svg"
              />
              <span>{itemData.timeAgoStr}</span>
              {#if itemData.canEdit}
                <button
                  class="btn bg-transparent shadow-none border-0 p-0 m-0 ms-2 color-blue font-size-12"
                  on:click={() => showEdit(itemData.id)}
                >
                  <img
                    class=" icon-12"
                    alt=""
                    src="/images/pencil-gray.svg"
                  />
                </button>
              {/if}
              {#if itemData.canDelete}
                <button
                  class="btn bg-transparent shadow-none border-0 p-0 m-0 ms-2 color-blue font-size-12"
                  on:click={() => showDelete(itemData.id)}
                >
                  <img
                    class=" icon-12"
                    alt=""
                    src="/images/cancel.svg"
                  />
                </button>
              {/if}
            </small>
          </div>
          <div
            class="ql-editor"
            style="padding:0 !important;    xborder-width: 0 !important;"
          >
            <ReadMoreHeight
              class="mt-2"
              label={itemData.notes != null ? itemData.notes : ''}
              showSticky={itemData.sticky == 1}
              onSticky={() => {
                client.taskNotesUnsticky({
                  taskId: id,
                  id: itemData.id,
                });
                itemData.sticky = 0;
              }}
            ></ReadMoreHeight>
          </div>
        </div>
      </div>
    </div>
  {/each}
  <InfiniteScroll
    threshold={300}
    reverse={true}
    key={taskCommentsData.length}
    hasMore={hasMore}
    isLoading={isPaginationLoading}
    on:loadMore={() => {
      pageNumber = pageNumber + 1;
      getNotesList();
    }}
  >
    <div
      class="scroll-spinner-container d-flex justify-content-center
			align-items-center"
    >
      <Loader Style="loader-block" />
    </div>
  </InfiniteScroll>
</div>

<div class="comments-block px-3 pb-3 position-relative">
  <div class="form-textarea quill-white position-relative task-note-editor">
    <!-- <textarea name="comment" placeholder="Enter Comments" bind:value={commentValues.notes} on:change={() => commentError= false} on:input={() => commentError= false}/> -->
    <div bind:this={tagifyRef}>
      <slot></slot>
    </div>

    <button
      class="send position-absolute color-blue font-weight-600 border-0 mb-0 rounded-circle background-blue"
      on:click={handleSubmit}
    >
      <img
        alt=""
        src="/images/send.svg"
      />
    </button>
    {#if commentValues.id && commentValues.id > 0}
      <button
        title="Undo Editing"
        class="position-absolute close-tagy-btn"
        style="top:0px;"
        on:click={() => {
          commentValues = { ...defaultValue };
          tagify.setContents('');
        }}
      >
        <img
          alt=""
          src="/images/cross-white.svg"
        />
      </button>
    {:else}
      <div class=" d-flex flex-row button-action-bottom align-items-center position-absolute">
        <div class="checkbox c-checkbox">
          <label class="text-muted">
            <input
              type="checkbox"
              name="live_bidding"
              bind:checked={commentValues.client}
              on:change={(event) => {
                commentValues.saveClient = event.target.checked ? 1 : 0;
              }}
            />
            <span class="check-img" />
            Add to client notes
          </label>
        </div>
        <div class="checkbox c-checkbox">
          <label
            class="text-muted subtask_popover"
            data-bs-placement="top"
            data-bs-toggle="popover"
            data-bs-trigger="hover focus"
            data-bs-content="Click here to tag to already open and future tasks."
          >
            <input
              type="checkbox"
              name="sticky"
              bind:checked={commentValues.sticky}
              on:change={(event) => {
                commentValues.sticky = event.target.checked ? 1 : 0;
              }}
            />
            <span class="check-img" />
            Make it sticky
          </label>
        </div>
      </div>
    {/if}
    {#if commentError}
      <label class="formError">Comment required</label>
    {/if}
  </div>
</div>

<style lang="scss">
  :global(.task-note-editor .ql-container) {
    padding-bottom: 24px;
  }
  .comments-list {
    .comments-user-profile-img {
      flex: 0 0 40px;
      max-width: 40px;
    }
  }
  .comments-block {
    .button-action-bottom {
      bottom: 4px;
      padding-left: 11px;
    }
  }
  :global(.task-note-editor .ql-toolbar.ql-snow + .ql-container.ql-snow) {
    border-bottom: 0px;
  }
  .form-textarea {
    border: 1px solid $input-border-color !important;
    min-height: 150px;
    border-radius: 4px;
    textarea {
      height: 120px;
      width: 100%;
      border: 0px;

      resize: none;
      padding: 8px 65px 12px 12px;
    }
  }
  .send {
    width: 40px;
    height: 40px;
    right: 12px;
    top: 60px;
    img {
      width: 20px;
      height: 20px;
    }
    &:focus {
      background: $blue-color;
    }
  }
</style>
